import { ExceptionsClient } from "../client/ExceptionsClient";
import {getRelativeTime} from "../../util/CommonUtils";

export function getScrubInvocationDetails({scrubType}, dispatcher) {

    ExceptionsClient.getScrubInvocationDetails({
        scrubType : scrubType
    }).then(({valid, data}) => {
        if (valid) {
            dispatcher({
                type: "SET_DATA",
                data: prepareScrubInvocationAttributesList(data.scrubInvocationAttributesList)
            });
        }
    });

}

const prepareScrubInvocationAttributesList = (scrubInvocationAttributesList) => {
    return scrubInvocationAttributesList.map(({
                                                  scrubType,
                                                  updateStatusDate ,
                                                  operationPerson ,
                                                  stationCode ,
                                              }) => ({
        LAST_UPDATED: getRelativeTime(updateStatusDate),
        OPERATION_PERSON: operationPerson || "",
        STATION: stationCode || "",
    }));
}



// WEBPACK FOOTER //
// ./src/commons/api/ScrubInvocationDetailsAPI.js